import { Component, OnInit } from '@angular/core';
import { environment } from '@tech-environments/environment';

@Component({
  selector: 'tech-footermain',
  templateUrl: './footermain.component.html',
  styleUrls: ['./footermain.component.scss'],
})
export class FootermainComponent implements OnInit {
  public version: string = environment.appVersion;
  public year: number = new Date().getFullYear();

  constructor() {}

  ngOnInit() {}
}
